import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { CommunicationLanguage } from './communication-language.interface';

export class CommunicationLanguageService {
   async getCommunicationLanguages() {
      const response = await http.get<Array<CommunicationLanguage>>('/communication-languages', cacheFirstConfig);
      return response.data;
   }
}
